module.exports = __webpack_public_path__ + "img/choose-up-Up Social-disabled.8f5e8a8f.png";